import { Component, OnInit, SecurityContext } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { ActivatedRoute, Router } from '@angular/router'
import {
  CmsNavigationComponent,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import {
  NavigationNode,
  CmsComponentData,
  NavigationService,
  LaunchDialogService,
} from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { FOOTER_NAVIGATION_MENUS } from '../footer-navigation-menus.model'
import { FooterNavigationService } from '../footer-navigation.service'
import { environment } from '../../../../environments/environment'

declare const Optanon: any

@Component({
  standalone: false,
  selector: 'vs-footer-navigation',
  templateUrl: './footer-navigation.component.html',
  styleUrls: ['./footer-navigation.component.scss'],
})
export class FooterNavigationComponent implements OnInit {
  node$: Observable<NavigationNode> = this.service.getNavigationNode(
    this.componentData.data$
  )
  styleClass$: Observable<string> = this.componentData.data$.pipe(
    map((d) => d?.styleClass)
  )
  displayHelp: boolean = false
  displaySiteTour: boolean = false
  displayVideoTour: boolean = false
  termsLink: any = '/'

  constructor(
    protected componentData: CmsComponentData<CmsNavigationComponent>,
    protected service: NavigationService,
    protected launchDialogService: LaunchDialogService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private footerNavService: FooterNavigationService,
    private footerNavigationService: FooterNavigationService,
    private globalMessageService: GlobalMessageService,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.fetchTermsConditions()

    this.activatedRoute.params.subscribe(
      (data) => {
        this.displayHelp = false
        this.displaySiteTour = false
        this.displayVideoTour = false
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.activatedRoute.queryParams.subscribe(
      (data) => {
        this.displayHelp = false
        this.displaySiteTour = false
        this.displayVideoTour = false
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    this.footerNavService.openCloseSiteTourAction.subscribe(
      (data) => {
        if (data) {
          this.openSiteTour()
        } else {
          this.closeSiteTour()
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    this.footerNavService.openCloseVideoTourAction.subscribe(
      (data) => {
        if (data) {
          this.openVideoTutorial()
        } else {
          this.closeVideoTutorial()
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  helpCall(node) {
    switch (node.title) {
      case FOOTER_NAVIGATION_MENUS.HELP:
        this.displayHelp = true;
        break;
      case FOOTER_NAVIGATION_MENUS.COOKIES:
        Optanon.ToggleInfoDisplay();
        break;
      case FOOTER_NAVIGATION_MENUS.PRIVACY:
        (window as any).open(this.domSanitizer.sanitize(SecurityContext.URL,node.url), '_blank');
        break;
      case FOOTER_NAVIGATION_MENUS.ABOUT_US:
        (window as any).open(this.domSanitizer.sanitize(SecurityContext.URL,node.url), '_blank');
        break;
      default:
        this.router.navigate([node.url]);
        break;
    }
  }

  openSiteTour() {
    this.closeHelpMenu()
    this.displaySiteTour = true
  }

  closeSiteTour() {
    this.displaySiteTour = false
  }

  closeHelpMenu() {
    this.displayHelp = false
  }

  openVideoTutorial() {
    this.closeHelpMenu()
    this.displayVideoTour = true
  }
  closeVideoTutorial() {
    this.displayVideoTour = false
  }

  fetchTermsConditions() {
    this.footerNavigationService.fetchTermsConditionsLink().subscribe(
      (data) => {
        this.generateLinkToPDF(data)
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  generateLinkToPDF(responsePDF) {
    const pdfURL = responsePDF['media']?.downloadUrl
    const preUrl = environment.occBaseUrl // + environment.occPrefix + environment.occBaseSite;

    this.termsLink = this.domSanitizer.sanitize(
      SecurityContext.URL,
      preUrl + pdfURL
    )
  }
}
